const membershipPackageDetailsForEditing = (state = null, action) => {
  if (action.type === "SET_MEMBERSHIP_PACKAGE_DETAILS_FOR_EDITING") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_MEMBERSHIP_PACKAGE_DETAILS_FOR_EDITING": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default membershipPackageDetailsForEditing;
